import { createElement } from 'react';
import { Input as OriginalInput } from 'antd';
const Input = function AfulInput({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalInput, { ..._otherProps }));
};
export default Input;
